module.exports = __webpack_public_path__ + "static/media/team1.4ced432d.jpg";